<script setup lang="ts">
import { type LucideIcon } from "@lucide/vue";
import { RouterLink, useRoute } from "vue-router";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

defineProps<{
  items: {
    title: string;
    url: string;
    icon?: LucideIcon;
  }[];
}>();

const route = useRoute();
const { isMobile, setOpenMobile } = useSidebar();

// Tapping the entry for the page you are already on does not change the route,
// so the AppSidebar route watcher never fires; close the mobile sheet here too.
function onNavigate() {
  if (isMobile.value) setOpenMobile(false);
}

// Highlight the nav entry whose URL prefixes the current path (so /planning/new
// keeps "Planning" active). Root "/" matches exactly only.
function isActive(url: string): boolean {
  return url === "/" ? route.path === "/" : route.path.startsWith(url);
}
</script>

<template>
  <SidebarGroup>
    <SidebarMenu>
      <SidebarMenuItem v-for="item in items" :key="item.title">
        <SidebarMenuButton as-child :tooltip="item.title" :is-active="isActive(item.url)">
          <RouterLink :to="item.url" @click="onNavigate">
            <component :is="item.icon" v-if="item.icon" />
            <span>{{ item.title }}</span>
          </RouterLink>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  </SidebarGroup>
</template>
